import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { IntegrationsService } from '../../services/integrations.service';

@Component({
  selector: 'app-modal-param',
  standalone: true,
  imports: [
    MatIconModule,
    MatDialogModule,
    CommonModule,
    ReactiveFormsModule,
    MatChipsModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatSlideToggleModule,
    MatSelectModule
  ],
  templateUrl: './modal-param.component.html',
  styleUrl: './modal-param.component.css'
})
export class ModalParamComponent implements OnInit, OnDestroy {

  readonly dialog = inject(MatDialog);
  @Input() dialogRef: MatDialogRef<ModalParamComponent> = inject(MatDialogRef);

  public types: any[] = [
    { value: 'INTEGER', name: "INTEGER" },
    { value: 'STRING', name: "STRING" },
    //{ value: 'BOOLEAN', name: "BOOLEAN" },
  ];

  public editForm: FormGroup = new FormGroup({
    id: new FormControl(0, [Validators.required]),
    integrationId: new FormControl("", [Validators.required]),
    name: new FormControl("", [Validators.required]),
    type: new FormControl("1", [Validators.required]),
    val: new FormControl("", [Validators.required]),
  });

  constructor(
    public integrationsService: IntegrationsService,

  ) { }


  addParam() {
    this.integrationsService.addParam(this.editForm.value)
    .subscribe({
      next: (data: any) => {
        console.log("data", data);
        this.integrationsService.currentParam = data.parameter;
        this.integrationsService.setCurrentIntegration(data.integration);// = data.integration;
        this.dialogRef.close();
      },
      error: (error: any) => {
        console.error(error);
      }
    });
  }

  updateParam() {
    this.integrationsService.updateParam(this.editForm.value)
    .subscribe({
      next: (data: any) => {
        console.log("data", data);
        this.integrationsService.currentParam = data.parameter;
        this.integrationsService.setCurrentIntegration(data.integration);// = data.integration;
        this.dialogRef.close();
      },
      error: (error: any) => {
        console.error(error);
      }
    });
  }
  onSubmit() {
    console.log("submit")
    if (this.integrationsService.currentParam.id > 0) {
      this.updateParam();
    } else {
      this.addParam();
    }

  }


  ngOnInit(): void {
    if (this.integrationsService.currentParam.id > 0) {
      this.editForm.patchValue(this.integrationsService.currentParam);
    } else {
      this.editForm.patchValue({ integrationId: this.integrationsService.currentIntegration.id });
    }

  }

  ngOnDestroy(): void {
    console.log("ngOnDestroy");
    this.integrationsService.currentParam = { id: 0, integrationId: 0, name: "", type: "", val: "" };
  }

  checkDisabled() {
    console.log("checkDisabled", this.editForm);
    return this.editForm.invalid;
  }

  getTitle() {
    return this.integrationsService.currentParam.id > 0 ? "Edytuj parametr" : "Dodaj parametr";
  }
  getButtonText() {
    return this.integrationsService.currentParam.id > 0 ? "Zapisz" : "Dodaj";
  }
}
